import {
  CLICKED_CATEGORY,
  CLICKED_PRODUCT,
  DELETE_PRODUCT,
  UPDATE_PRODUCT,
  UPDATE_MENU,
  DELETE_MENU,
  ADD_PRODUCT,
} from "../types/cart.types";

import { FETCH_PRODUCTS_CART, SEND_ORDER } from "../types/order.types";
import { deepClone, deepCompare } from "../../utils/utils";

const initialState = {
  clickedProduct: {
    id: "",
    statusClicked: false,
  },
  categorySelected: "",
  productsRemoved: [],
  valueBasket: 0,
  basket: [],
};

const reducer = function orderReducer(state = initialState, action) {
  const newState = deepClone(state);
  switch (action.type) {
    case ADD_PRODUCT:
      const productPlus = action.response;
      return addProduct(newState, productPlus);
    case DELETE_PRODUCT:
      const productRemove = action.response;
      return substractProductQuantity(newState, productRemove);
    case UPDATE_PRODUCT:
      const { productUpdated, oldUniqueId } = action.response;
      return updateProductWithExtra(newState, productUpdated, oldUniqueId);
    case FETCH_PRODUCTS_CART:
      const { foundProducts } = action.response;
      newState.basket = foundProducts;
      newState.valueBasket = updateValueBasket(foundProducts);
      return newState;
    case SEND_ORDER:
      newState.basket = [];
      newState.valueBasket = 0;
      return newState;
    case UPDATE_MENU:
      const { menuUpdated, oldUniQId } = action.response;
      return updateMenu(newState, menuUpdated, oldUniQId);
    case DELETE_MENU:
      const menuRemoved = action.response;
      return deleteMenu(newState, menuRemoved);
    case CLICKED_PRODUCT:
      const idProduct = action.response;
      return updateClickedProduct(newState, idProduct);
    case CLICKED_CATEGORY:
      const category = action.response;
      return updateClickedCategory(newState, category);
    default:
      return newState;
  }
};

export default reducer;

function calcPriceExtraProduct(product) {
  let copyProduct = product;
  let priceTotalExtra = 0;

  if (copyProduct.extraCategories.length) {
    priceTotalExtra = calcValueExtra(copyProduct.extraCategories);
  }
  copyProduct.price_total_extra = priceTotalExtra;
  return copyProduct;
}

function calcValueExtra(extraCategories) {
  return extraCategories.reduce((acc, data) => {
    acc += data.total_price;
    return acc;
  }, 0);
}

function updateValueBasket(datas) {
  return datas.reduce((acc, item) => {
    const extra = item.price_total_extra ?? 0;
    acc += (item.price + extra) * item.selected_quantity;
    return acc;
  }, 0);
}

function addProduct(state, product) {
  let storedProducts = state.basket;
  let selectedProduct = product;
  const indexProductInCart = getIndexProductInCart(
    selectedProduct,
    storedProducts
  );

  if (indexProductInCart !== -1) {
    selectedProduct = calcPriceExtraProduct(selectedProduct);
    storedProducts[indexProductInCart] = selectedProduct;
  } else {
    selectedProduct = calcPriceExtraProduct(selectedProduct);
    storedProducts.push(selectedProduct);
  }
  state.valueBasket = updateValueBasket(storedProducts);
  return state;
}

function substractProductQuantity(state, product) {
  let storedProducts = state.basket;
  let selectedProduct = product;

  const indexProductInCart = getIndexProductInCart(
    selectedProduct,
    storedProducts
  );

  if (indexProductInCart !== -1) {
    if (selectedProduct.selected_quantity) {
      selectedProduct = calcPriceExtraProduct(selectedProduct);
      storedProducts[indexProductInCart] = selectedProduct;
    } else {
      storedProducts = storedProducts.filter(
        (strProduct) => strProduct.id != selectedProduct.id
      );
      state.productsRemoved = storeProductRemoved(
        state.productsRemoved,
        selectedProduct
      );
      state.basket = storedProducts;
    }
  }
  state.valueBasket = updateValueBasket(storedProducts);
  return state;
}

function updateProductWithExtra(state, product, oldUniqueId = false) {
  let storedProducts = state.basket;
  let selectedProduct = product;
  const isUpdate = oldUniqueId ? true : false;
  if (!selectedProduct.selected_quantity) {
    storedProducts = storedProducts.filter(
      (strProduct) =>
        deepCompare(strProduct.uniqueIdProduct) !==
        deepCompare(selectedProduct.uniqueIdProduct)
    );
    state.valueBasket = updateValueBasket(storedProducts);
    state.basket = storedProducts;
    return state;
  }

  if (isUpdate) {
    if (deepCompare(product.uniqueIdProduct) === deepCompare(oldUniqueId)) {
      const indexProduct = getUniqueIdProductIndexInCart(
        storedProducts,
        oldUniqueId
      );
      if (indexProduct !== -1) {
        selectedProduct = calcPriceExtraProduct(selectedProduct);
        selectedProduct.uniqueIdProduct = selectedProduct.newUniqueIdProduct;
        delete selectedProduct.newUniqueIdProduct;
        storedProducts[indexProduct] = selectedProduct;
      }
      state.basket = storedProducts;
    } else {
      const indexProduct = getUniqueIdProductIndexInCart(
        storedProducts,
        oldUniqueId
      );
      if (indexProduct !== -1) {
        storedProducts = storedProducts.filter(
          (strProduct) =>
            deepCompare(strProduct.uniqueIdProduct) !== deepCompare(oldUniqueId)
        );
        //verifier que uniqueid existe pas deja si il existe ajouter les quantité du nouveau produit a celui qui existe dna sle panier
        const findUniqueIdExist = getUniqueIdProductIndexInCart(
          storedProducts,
          selectedProduct.uniqueIdProduct
        );
        if (findUniqueIdExist !== -1) {
          storedProducts = mergeProducts(
            findUniqueIdExist,
            storedProducts,
            selectedProduct
          );
          state.basket = storedProducts;
        } else {
          selectedProduct = calcPriceExtraProduct(selectedProduct);
          storedProducts.push(selectedProduct);
          state.basket = storedProducts;
        }
      }
    }
  } else {
    //verifier que uniqueid existe pas deja si il existe ajouter les quantité du nouveau produit a celui qui existe dna sle panier
    const findUniqueIdExist = getUniqueIdProductIndexInCart(
      storedProducts,
      selectedProduct.uniqueIdProduct
    );
    if (findUniqueIdExist !== -1) {
      storedProducts = mergeProducts(
        findUniqueIdExist,
        storedProducts,
        selectedProduct
      );
      state.basket = storedProducts;
    } else {
      selectedProduct = calcPriceExtraProduct(selectedProduct);
      storedProducts.push(selectedProduct);
      state.basket = storedProducts;
    }
  }
  state.valueBasket = updateValueBasket(storedProducts);
  return state;
}

function getIndexProductInCart(product, cartProducts) {
  return cartProducts.findIndex((cartProduct) => cartProduct.id == product.id);
}

function getUniqueIdProductIndexInCart(cartProducts, uniqueId) {
  return cartProducts.findIndex(
    (cartProduct) =>
      deepCompare(cartProduct.uniqueIdProduct) === deepCompare(uniqueId)
  );
}

function mergeProducts(index, cartProducts, product) {
  const copyCartProducts = cartProducts;
  copyCartProducts[index].selected_quantity = product.selected_quantity;
  delete copyCartProducts[index].removeId;
  return copyCartProducts;
}

function storeProductRemoved(productsRemoved, productDeleted) {
  const isProductAlreadyRemoved = productsRemoved.find(
    (prodRemoved) =>
      prodRemoved.id_order_line == productDeleted.id_order_line &&
      prodRemoved.id == productDeleted.id
  );

  if (isProductAlreadyRemoved) {
    return productsRemoved;
  } else {
    return [...productsRemoved, productDeleted];
  }
}

function updateMenu(state, menu, oldUniqueId = false) {
  let storedMenus = state.basket;
  const isUpdate = oldUniqueId;
  if (isUpdate) {
    if (deepCompare(menu.uniqueIdProduct) === deepCompare(oldUniqueId)) {
      const indexMenu = getUniqueIdProductIndexInCart(storedMenus, oldUniqueId);
      if (indexMenu !== -1) {
        storedMenus[indexMenu] = menu;
      }
      state.basket = storedMenus;
    } else {
      const findMenuUniqueIdExist = getUniqueIdProductIndexInCart(
        storedMenus,
        menu.uniqueIdProduct
      );
      if (findMenuUniqueIdExist !== -1) {
        storedMenus = mergeMenus(findMenuUniqueIdExist, storedMenus, menu);
        storedMenus = storedMenus.filter((strMenu) => {
          return (
            deepCompare(strMenu.uniqueIdProduct) !== deepCompare(oldUniqueId)
          );
        });
      } else {
        const findIndexMenuExist = getUniqueIdProductIndexInCart(
          storedMenus,
          oldUniqueId
        );
        storedMenus[findIndexMenuExist] = menu;
      }
    }
  } else {
    const findMenuUniqueIdExist = getUniqueIdProductIndexInCart(
      storedMenus,
      menu.uniqueIdProduct
    );
    if (findMenuUniqueIdExist !== -1) {
      storedMenus = mergeMenus(findMenuUniqueIdExist, storedMenus, menu);
    } else {
      storedMenus.push(menu);
    }
  }

  state.basket = storedMenus;
  state.valueBasket = updateValueBasket(storedMenus);
  return state;
}

function deleteMenu(state, menuRemoved) {
  let storedProductsNMenu = state.basket;
  storedProductsNMenu = storedProductsNMenu.filter(
    (menu) => menu.id_order_line !== menuRemoved.id_order_line
  );
  state.basket = storedProductsNMenu;
  state.valueBasket = updateValueBasket(storedProductsNMenu);
  return state;
}

function mergeMenus(index, cartMenus, menu) {
  const copyCartMenus = cartMenus;
  copyCartMenus[index].selected_quantity = menu.selected_quantity;
  delete copyCartMenus[index].removeId;
  return copyCartMenus;
}

function updateClickedProduct(state, idProduct) {
  let newClickedProduct = state.clickedProduct;
  newClickedProduct.id = idProduct;
  newClickedProduct.statusClicked = true;
  state.clickedProduct = newClickedProduct;
  return state;
}

function updateClickedCategory(state, idCategory) {
  state.categorySelected = idCategory;
  return state;
}
